import { render, staticRenderFns } from "./ViewCustomPolygon.vue?vue&type=template&id=c63f484e"
import script from "./ViewCustomPolygon.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewCustomPolygon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ViewCustomPolygon.vue?vue&type=style&index=0&id=c63f484e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports